import React, {Component} from 'react';
import {Translate} from 'react-localize-redux';
import {connect} from 'react-redux';

import './style.css';
import Header from "../../Header/index";
import MainMenu from "../../MainMenu/index";
import Footer from "../../Footer/index";
import Alert from "../../../03-components/Alert";
import FeaturedItems from "../../FeaturedItems/index";
import BrandLogos from "../../BrandLogos/index";
import {Redirect, Route, Switch, withRouter} from "react-router-dom";
import ProductsPage from './Products';
import ContactPage from './Contact';
import {loadImages} from "../../../01-actions/adminImages";
import Carousel from '../../Carousel';
import PromoPhotos from "../../PromoPhotos/index";
import CategorySelector from '../../CategorySelector';
import {getSystemStatus} from "../../../01-actions/system";

class HomePage extends Component {
	constructor(props) {
		super(props);
		props.getSystemStatus();
		props.loadImages();
	}
	
	render() {
		return (
			<Translate>
				{({translate}) => (
					<div className="pages-home">
						{this.props.systemStatus && this.props.systemStatus.MAINTAIN_MODE &&
						<Redirect to="/maintain"/>
						}
						<Header to="/admin" subTitle="Official website"/>
						<div className="d-flex flex-column flex-grow-1">
							<div className="main-content">
								{this.props.appCurrentError &&
								<Alert header={translate("error")}
								       content={translate("errors." + this.props.appCurrentError.code)}
								       okTitle={translate("ok")}/>
								}
								<div>
									<Carousel className="margin-top-20px"/>
									<div className="margin-top-40px"/>
									<div className="home-body d-flex">
										<CategorySelector onSelected={(category)=>{
											this.props.history.push(`/products?categoryId=${category}`);
										}}/>
										<MainMenu/>
										<Switch>
											<Route path="/contact" component={ContactPage}/>
											<Route path="/products" component={ProductsPage}/>
											<Route exact path="/">
												<div className="d-flex width-100">
													<FeaturedItems className="flex-grow-1"/>
													<PromoPhotos/>
												</div>
											</Route>
										</Switch>
									</div>
								</div>
							</div>
							<div className="margin-top-40px"/>
							<BrandLogos/>
						</div>
						<div className="margin-top-40px"/>
						<Footer/>
					</div>
				)}
			</Translate>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		systemStatus: store.system.systemStatus,
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		loadImages: () => {
			dispatch(loadImages());
		},
		getSystemStatus: () => {
			dispatch(getSystemStatus());
		}
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomePage));


// WEBPACK FOOTER //
// ./src/04-containers/_pages/Home/index.js